module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"script_started","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"label":{"type":"string"},"ls":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"levelID":{"type":"string","maxLength":128}},"required":["user","ls","levelID"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/script_started.json
// module id = 571
// module chunks = 100